import React from "react";
import "../styling/skills.css";

function Skills() {
  return (
    <div className="container-skills">
      <div className="wrapper">
        <div className="title-skills">
          <h2>Skills</h2>
        </div>
        <div className="skills-content">
          <div className="skills-entry">
            <div className="skills-list">
              <ul>
                <div className="skills-data-title">
                  <p>Programming Languages: </p>
                </div>
                <li>
                  <p>Python</p>
                </li>
                <li>
                  <p>C++</p>
                </li>
                <li>
                  <p>C#</p>
                </li>
                <li>
                  <p>GoLang</p>
                </li>

                <li>
                  <p>JavaScript/TypeScript</p>
                </li>
                <li>
                  <p>C</p>
                </li>
                <li>
                  <p>CMake</p>
                </li>
                <li>
                  <p>Java</p>
                </li>
                <li>
                  <p>HTML</p>
                </li>
                <li>
                  <p>CSS</p>
                </li>
              </ul>
            </div>
          </div>
          <div className="skills-entry">
            <div className="skills-list">
              <ul>
                <div className="skills-data-title">
                  <p>Frameworks/Libraries: </p>
                </div>
                <li>
                  <p>React</p>
                </li>
                <li>
                  <p>.NET</p>
                </li>
                <li>
                  <p>Qt</p>
                </li>
                <li>
                  <p>NEXT.js</p>
                </li>
                <li>
                  <p>Pandas</p>
                </li>
                <li>
                  <p>Tensorflow</p>
                </li>
                <li>
                  <p>SciPy</p>
                </li>
                <li>
                  <p>NumPy</p>
                </li>
                <li>
                  <p>TailwindCSS</p>
                </li>

                <li>
                  <p>JEST.io</p>
                </li>
                <li>
                  <p>BluebirdJS</p>
                </li>
                <li>
                  <p>Flask</p>
                </li>
                <li>
                  <p>WebRTC</p>
                </li>
                <li>
                  <p>GStreamer</p>
                </li>
              </ul>
            </div>
          </div>
          <div className="skills-entry">
            <div className="skills-list">
              <ul>
                <div className="skills-data-title">
                  <p>Databases: </p>
                </div>
                <li>
                  <p>Azure Cosmos DB</p>
                </li>
                <li>
                  <p>RESTful API</p>
                </li>
                <li>
                  <p>MongoDB</p>
                </li>
                <li>
                  <p>SQL</p>
                </li>
                <li>
                  <p>SQLite</p>
                </li>
                <li>
                  <p>GraphQL</p>
                </li>
              </ul>
            </div>
          </div>
          <div className="skills-entry">
            <div className="skills-list">
              <ul>
                <div className="skills-data-title">
                  <p>Development Tools: </p>
                </div>
                <li>
                  <p>Git</p>
                </li>
                <li>
                  <p>Bitbucket</p>
                </li>
                <li>
                  <p>JIRA</p>
                </li>
                <li>
                  <p>Azure DevOps</p>
                </li>
                <li>
                  <p>Postman</p>
                </li>
                <li>
                  <p>Sourcetree</p>
                </li>
                <li>
                  <p>Visual Studio</p>
                </li>
                <li>
                  <p>SonarQube</p>
                </li>
                <li>
                  <p>Agile</p>
                </li>
                <li>
                  <p>Docker</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skills;
